import { DisciplineResults } from '../../Components/DisciplineResults';

export const BlackPowderSilhouetteResults = () => {
  return (
    <DisciplineResults 
      discipline="BLACK_POWDER_SILHOUETTE" 
      disciplineName="Black Powder Silhouette"
    />
  );
};
